import styled from 'styled-components'

export const TableRow = styled.tr`
  vertical-align: baseline;
`

export const InputWrapper = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
`
